import { Component, OnInit, ChangeDetectorRef } from '@angular/core';
import { FormArray, FormBuilder, FormGroup, Validators, AbstractControl, ValidationErrors, FormControl } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { BehaviorSubject } from 'rxjs';
import { EventsAdminService } from '../../services/events-admin.service';
import { EventsAdmin, EventStatus } from 'src/app/core/models/events-admin/events-admin';
import { BentoContextualHeaderItem, BentoComboboxOptions, BentoComboboxColumn } from '@bento/bento-ng';
import { LayoutService } from 'src/app/core/services/layout.service';
// import { PopmodalService } from "src/app/core/services/popupmodel.service";
//import { ToasterService, ToasterConfig } from "angular2-toaster";

import {BentoModalConfirmationCloseReason, BentoModalConfirmationService, BentoToastService} from '@bento/bento-ng';
import { PopmodalService } from 'src/app/core/services/popupmodel.service';
import { distinctUntilChanged } from 'rxjs/operators';


@Component({
  selector: "app-registration-page",
  templateUrl: "./registration-page.component.html",
  styleUrls: ["./registration-page.component.scss"],
})
export class RegistrationPageComponent implements OnInit {
  eventsRegistrationForm: FormGroup;
  selectedProduct: any;
  selectedChannel: any;
  selectedSchema: any;
  selectedStatus: EventStatus;
  channels: any[] = [];
  schemas: any[] = [];
  products: any[] = [];
  dataProductsEmitter: BehaviorSubject<any> = new BehaviorSubject([]);
  dataChannelsEmitter: BehaviorSubject<any> = new BehaviorSubject([]);
  dataSchemasEmitter: BehaviorSubject<any> = new BehaviorSubject([]);
  dataStreamStatus: BehaviorSubject<any> = new BehaviorSubject([]);
  items: BentoContextualHeaderItem[];
  eventId: string;
  creationDate: string;
  isEditMode: boolean = false;
  comboboxOptions: BentoComboboxOptions = {
    searchable: false,
    columns: [
      {
        name: "name",
        width: "40px",
      },
    ] as BentoComboboxColumn[],
    labelFormatter: (row) => {
      return row.name;
    },
  };
  comboboxSchemaOptions: BentoComboboxOptions = {
    searchable: false,
    columns: [
      {
        name: "display_name",
        width: "40px",
      },
    ] as BentoComboboxColumn[],
    labelFormatter: (row) => {
      return row.display_name;
    },
  };
  comboboxOptionsStatus: BentoComboboxOptions = {
    searchable: true,
    autoSelect: false,
  };
  selectedProductId: string;
  selectedChannelId: string;
  selectedSchemalId: string;
  selectedSchemaIdToEdit: string;
  isMainBusyLoader: boolean;
  doesNotContainDash: boolean = false;
  emptyDescription: boolean = false;
  isValidUrl: boolean = true;
  existingGFREvents: EventsAdmin[] = [];
  eventNameAlreadExist: boolean = false;

  constructor(
    private fb: FormBuilder,
    private router: Router,
    private route: ActivatedRoute,
    private eventsAdminService: EventsAdminService,
    private layoutService: LayoutService,
    // toasterService: ToasterService,
    private popModalService: PopmodalService,
    //private modalService: BentoModalConfirmationService,
    private toastService: BentoToastService, //private bentoModalService: BentoModalService // Inject BentoModalService
    private cdr: ChangeDetectorRef // Inject ChangeDetectorRef
  ) {
    //this.toasterService = toasterService;
    this.items = [
      new BentoContextualHeaderItem("Add Event registration", undefined, undefined),
    ];
    this.selectedSchemaIdToEdit = this.route.snapshot.queryParams["schemaId"];
    this.eventsAdminService.currentEventDetailsGFR.subscribe((eventDetailsGFR) => {
      this.existingGFREvents = eventDetailsGFR;
    });
    this.createForm();
  }

  createForm(){
    this.eventsRegistrationForm = this.fb.group({
      eventName: new FormControl('', Validators.required),
      eventDescription: new FormControl('', Validators.required),
    });
  }

  ngOnInit(): void {
    this.initializeForm();
    this.loadData();
    const navigation = this.router.getCurrentNavigation();
    if (navigation?.extras?.state?.event) {
      const event = navigation.extras.state.event as EventsAdmin;
      this.eventId = event.id;
      this.items = [
        new BentoContextualHeaderItem("Edit Event registration", undefined, undefined),
      ];
      this.populateForm(event);
    } else {
      this.route.queryParams.subscribe((params) => {
        const eventId = params["id"];
        if (eventId) {
          this.eventId = eventId;
          this.isEditMode=true;
          this.eventsAdminService.fetchEvents().subscribe((events) => {
            const event = events.find((event) => event.id === eventId);
            event.description= params["description"];
            event.schemaId=params["schemaId"];
            if (event) {
              this.items = [
                new BentoContextualHeaderItem(
                  "Edit Event registration",
                  undefined,
                  undefined
                ),
              ];
              this.populateForm(event);
            }
          });
        }
      });
    }

    // Convert enum to array and bind to dataStreamStatus
    const statusArray = Object.keys(EventStatus).filter((key) =>
      isNaN(Number(key))
    );
    this.dataStreamStatus.next(statusArray);
    if(this.isEditMode){
      this.disableControls();
    }
  }

  initializeForm(): void {
    this.eventsRegistrationForm = this.fb.group({
      eventName: ["", Validators.required],
      eventDescription: [""],
      eventCallback: ["", [Validators.required, this.urlValidator]],
      eventProduct: ["", Validators.required],
      eventChannel: ["", Validators.required],
      eventSchema: ["", Validators.required],
      eventStatus: ["", Validators.required],
      distributionAttributes: this.fb.array([]),
    });
  }

  get distributionAttributes(): FormArray {
    return this.eventsRegistrationForm.get(
      "distributionAttributes"
    ) as FormArray;
  }

  addAttribute(): void {
    this.distributionAttributes.push(
      this.fb.group({
        field: ["", Validators.required],
        operator: ["", Validators.required],
        value: ["", Validators.required],
      })
    );
  }

  removeAttribute(index: number): void {
    this.distributionAttributes.removeAt(index);
  }

  loadData(): void {
    // this.layoutService.setBusyLoader(true);
    this.isMainBusyLoader = true;
    if (this.route.snapshot.queryParams["id"] !== undefined) {
      this.populateProductAndChannels();
    } else {
      this.eventsAdminService.getProductBasedOnEnvironment().subscribe((res) => {
        this.products = [res];
        this.dataProductsEmitter = new BehaviorSubject([]);
        this.dataProductsEmitter.next(this.products);
        // subscribing to valueChanges of each form control
        for (const key of Object.keys(this.eventsRegistrationForm.controls)) {
          this.eventsRegistrationForm.controls[key].valueChanges.subscribe((value) => {          
            if (key === 'eventProduct') {
              this.selectedProduct = value;
              this.selectedProductId = value?.id;
              this.eventsAdminService.fetchChannels().subscribe((res) => {
                this.channels = res;
                this.dataChannelsEmitter = new BehaviorSubject([]);
                this.dataChannelsEmitter.next(this.channels);
              });
            }

            if (key === 'eventChannel') {
              this.selectedChannel = value;
              this.selectedChannelId = value?.id;
              this.eventsRegistrationForm.patchValue({
                eventSchema: ''
              });
              this.fetchSchemasBasedOnChannel(Number(this.selectedChannelId));
            }
          });
        }
        });
        this.isMainBusyLoader = false;
    }

    this.layoutService.setBusyLoader(false);
  }

  populateProductAndChannels(): void {
    this.eventsAdminService.getProductBasedOnEnvironment().subscribe((res) => {
      this.products = [res];
      this.selectedProduct = this.products[0];
      this.selectedProductId = this.products[0]["id"];
      this.dataProductsEmitter = new BehaviorSubject([this.selectedProduct]);
      this.eventsRegistrationForm.patchValue({
        eventProduct: this.selectedProduct
      });
    });

    this.eventsAdminService.fetchChannels().subscribe((channelsResponse) => {
      this.channels = channelsResponse;
      this.selectedChannelId = this.route.snapshot.queryParams["channelId"];
      this.selectedChannel = channelsResponse.find(el => el.id === Number(this.selectedChannelId));
      this.dataChannelsEmitter = new BehaviorSubject([this.selectedChannel]);
      this.eventsRegistrationForm.patchValue({
        eventChannel: this.selectedChannel
      });
      this.fetchSchemasBasedOnChannel(Number(this.route.snapshot.queryParams["channelId"]));
      this.eventsRegistrationForm.valueChanges.pipe(distinctUntilChanged())?.subscribe((schemaSelection) => {
           this.selectedSchema = schemaSelection.eventSchema;
           this.selectedSchemalId = schemaSelection.eventSchema?.id;
      });
    });
  }

  fetchSchemasBasedOnChannel(channelId: number): void {
    this.layoutService.setBusyLoader(true);
    const submitButton = document.getElementById("submit") as HTMLElement;

    if (channelId !== null) {
      this.eventsAdminService.fetchSchemas(channelId).subscribe((res) => {
        if (res.length === 0 && !Number.isNaN(channelId)) {
          this.dataSchemasEmitter = new BehaviorSubject([]);
          this.dataSchemasEmitter.next([
            {
              "id": "No-Schema",
              "display_name": "No Schemas found for this channel",
            }]);
          submitButton.setAttribute("disabled", "true");
        } else {
          this.dataSchemasEmitter = new BehaviorSubject([]);
          this.eventsRegistrationForm.patchValue({
            eventSchema: ''
          });
          this.dataSchemasEmitter.next(res);
          submitButton.removeAttribute("disabled");
        }
        this.schemas = res;
        let selectedSchemaToEdit = this.schemas.find(el => el.id === this.selectedSchemaIdToEdit);
        if (selectedSchemaToEdit !== undefined) {
          this.eventsRegistrationForm.patchValue({
            eventSchema: selectedSchemaToEdit
          });
        }
      this.isMainBusyLoader = false;

      });
    }
  }

  populateForm(event: EventsAdmin): void {
    this.selectedChannel = this.channels.find((c) => c.id === Number(this.selectedChannelId));
    this.selectedProduct = this.products.find((c) => c.id === Number(this.selectedProductId)); // event.product);
    if (this.schemas.length === 0) {
      this.eventsAdminService.fetchSchemas(Number(this.selectedChannelId)).subscribe((res) => {
        this.schemas = res;
      });
    }
    this.selectedSchema = this.schemas.find((s) => s.id === Number(this.selectedSchemalId)); // event.product);
    this.eventsRegistrationForm.patchValue({
      eventName: event.name,
      eventDescription: event.description,
      eventCreationDate: event.creationDate,
      eventCallback: event.url,
      eventProduct: this.selectedProduct,
      eventChannel: this.selectedChannel,
      eventSchema: this.selectedSchema || "",
      eventStatus: EventStatus[event.endpoint_state]
    });

    // Populate distribution attributes
    this.distributionAttributes.clear();
    event.distribution_attributes.forEach((attr) => {
      this.distributionAttributes.push(
        this.fb.group({
          field: attr.field,
          operator: attr.operator,
          value: attr.value,
        })
      );
    });
  }

  onSubmit(): void {
    this.isMainBusyLoader = true;

    if (this.eventNameAlreadExist){
      this.displayValidationErrors();
      return;
    }

    const formValue = this.eventsRegistrationForm.value;
    let event: EventsAdmin;
    if (this.route.snapshot.queryParams["id"] !== undefined) {
      event = this.updatedEvent(formValue);
    } else if (this.eventsRegistrationForm.valid) {
        this.selectedProduct = this.products.find(
          (product) => product.id === formValue.eventProduct.id
        );
        this.selectedChannel = this.channels.find(
          (channel) => channel.id === formValue.eventChannel?.id
        );
        this.selectedSchema = this.schemas.find(
          (schema) => schema.id === formValue.eventSchema?.id
        );
        event = this.updatedEvent(formValue);
    }
    else {
      this.displayValidationErrors();
    }
  
      if (this.eventId) {
        this.eventsAdminService.updateEvent(this.eventId, event).subscribe({
          next: (response) => {
            this.toastService.open("Event Updated Successfully!", {
              type: "success",
              duration: 2500,
            });
            this.updateGFREventDetails(event);
            this.eventsRegistrationForm.reset();
            this.router.navigate(['eventsAdmin/show-all-events'], { state: { refresh: true } });
            this.isMainBusyLoader = false;
          },
          error: (error) => {
            let errorMsg = "Error updating event!";
            if (error && Array.isArray(error.error)) {
              errorMsg = error.error
                .map((err) => `${err.field}: ${err.error}`)
                .join(" ");
            }
            this.toastService.open(errorMsg, { type: "danger", duration: 2500 });
            this.isMainBusyLoader = false;
          },
        });
      } else {
        this.eventsAdminService.addEvent(event).subscribe({
          next: (response) => {
            this.eventId= response.id;
            this.toastService.open("Event Created Successfully!", {
              type: "success",
              duration: 2500,
            });
            event.id=this.eventId;
            event.creationDate=(new Date()).toJSON();

            this.saveGFREventDetails(event);
            this.eventsRegistrationForm.reset();
            this.router.navigate(['eventsAdmin/show-all-events'], { state: { refresh: true } });
            this.isMainBusyLoader = false;
          },
          error: (error) => {
            let errorMsg = "Error creating event!";
            if (error && Array.isArray(error.error)) {
              errorMsg = error.error
                .map((err) => `${err.field}: ${err.error}`)
                .join(" ");
            }
            this.toastService.open(errorMsg, { type: "danger", duration: 2500 });
            this.isMainBusyLoader = false;
          },
        });
      }
  }

  updatedEvent(formValue: any): EventsAdmin {
    let updatedEventValue : EventsAdmin = {
      id: this.eventId || "",
      name: formValue.eventName,
      description: formValue.eventDescription,
      url: formValue.eventCallback,
      product: this.selectedProduct ? this.selectedProduct.id : null,
      channel_id: this.selectedChannel ? this.selectedChannel.id : null,
      schemaId: this.selectedSchema? this.selectedSchema.id: null,
      endpoint_state: EventStatus[formValue.eventStatus],
      eventName: "",
      createdBy: "",
      ordering_enabled: false,
      distribution_attributes: formValue.distributionAttributes.map(
        (attr) => ({
          field: attr.field,
          operator: attr.operator,
          value: attr.value,
        })
      ),
      associatedProduct: "",
      associatedChannel: "",
    };
    return updatedEventValue;
  }

  backButtonClick(): void {
    this.router.navigate(["eventsAdmin/show-all-events"]);
  }

  displayValidationErrors(): void {
    const controls = this.eventsRegistrationForm.controls;
    let errorMessages: string[] = [];

    if (controls.eventName.errors?.required) {
      errorMessages.push("Event Name");
    }
    if (this.eventNameAlreadExist){
      errorMessages.push("Event Name already exists");
    }
    if (
      controls.eventCallback.errors?.required ||
      controls.eventCallback.errors?.invalidUrl
    ) {
      errorMessages.push("Callback URL (must start with 'https://')");
    }
    if (controls.eventProduct.errors?.required) {
      errorMessages.push("Product");
    }
    if (controls.eventChannel.errors?.required) {
      errorMessages.push("Channel");
    }
    if (controls.eventStatus.errors?.required) {
      errorMessages.push("Status");
    }

    if (controls.eventSchema.errors?.required) {
      errorMessages.push("Schema");
    }

    if (errorMessages.length > 0) {
      this.popModalService.alert(
        "warning",
        `Please fill in all required fields: ${errorMessages.join(", ")}.`
      );
      this.isMainBusyLoader = false;
    }

  }

  private urlValidator(control: AbstractControl): ValidationErrors | null {
    const url = control.value;
    if (url && !url.startsWith("https://")) {
      return { invalidUrl: 'URL must start with "https://"' };
    }
    return null;
  }
  private saveGFREventDetails(event:EventsAdmin){
    this.eventsAdminService.addEventGFR(event).subscribe({
      next: (response) => {
      this.isMainBusyLoader = false;
      },
      error: (error) => {
      },
    });
  }
  private updateGFREventDetails(event:EventsAdmin){
    this.eventsAdminService.updateEventGFR(event).subscribe({
      next: (response) => {
      this.isMainBusyLoader = false;
      },
      error: (error) => {
      },
    });
  }
  disableControls():void{
    this.eventsRegistrationForm.get('eventProduct')?.disable();
    this.eventsRegistrationForm.get('eventChannel')?.disable();
  }

  onEventNameKeyup(event: KeyboardEvent): void {
    const input = event.target as HTMLInputElement;
    this.doesNotContainDash = input.value.indexOf('-') === -1;
    this.eventNameAlreadExist = false;
    if (input.value.length === 0) {
      this.doesNotContainDash = false;
    }
    this.cdr.detectChanges(); // Trigger change detection
  }

  onEventNameFocusOut(event: any): void {
    if (this.existingGFREvents.length > 0 && this.existingGFREvents.some(gfrEvent => this.nameExistsInGFREvents([gfrEvent], event.currentTarget.value))) {
      this.eventNameAlreadExist = true;
      this.doesNotContainDash = false;
    }
  }

  nameExistsInGFREvents(jsonObjects: any[], inputName: string): boolean {
    const trimmedInputName = inputName.trim(); // Trim whitespace from input
    const nameExists = jsonObjects[0].some(obj => {
      const trimmedObjName = obj.name?.trim() ?? ""; // Trim whitespace from object name, handle undefined
      return trimmedObjName === trimmedInputName; // Exact comparison (case-sensitive)
    });
    return nameExists;
  }

  onEventDescriptionKeyEvent(event: KeyboardEvent): void {
    const input = event.target as HTMLInputElement;
    this.emptyDescription = input.value.length === 0;
    this.cdr.detectChanges(); // Trigger change detection
  }

  onEventUrlKeyEvent(event: KeyboardEvent): void {
    const input = event.target as HTMLInputElement;
    const urlPattern = /^https:\/\/.*/;
    if (input.value.length === 0) {
      this.isValidUrl = true;
    }
    this.isValidUrl = urlPattern.test(input.value);
  }
}